import { c_cities, CCity } from '../mdl/c-city';
import { cEventsKeyNameView } from '../mdl/c-event-admin';
import { c_event_tags, cEventTagName } from '../mdl/c-event-tag';
import { c_producers } from '../mdl/c-producer';
import { CPlanId } from '../mdl/c-user';
import { c_venues } from '../mdl/c-venue';
import { fPagesGetListView } from '../mdl/f-page';
import { MChannel } from '../mdl/m-message';
import { m_templates, MContext, MTemplate } from '../mdl/m-template';
import { PPromo } from '../mdl/p-promo';
import { pPromoDiscountDescription, p_promos } from '../mdl/p-promo-admin';
import { v_videos } from '../mdl/v-video';
import { UISelect, UISelectOptions } from '../ui/component/select';
import { $el } from '../ui/elements';
import { UIValue } from '../ui/types';
import { $fn } from '../y/fn';
import { $i18n, YLanguage } from '../y/i18n';
import { YId, YCountryId } from '../y/types';

interface CitySelectOptions extends UISelectOptions<YId, YId | undefined> {
    signup?: boolean;
}

export class ABCitySelect extends UISelect<YId> {
    constructor(options: CitySelectOptions = {}) {
        options.placeholder = options.placeholder || 'Choose a city';
        options.searchable = true;

        super(ABCitySelect.makeValues(c_cities.all, options.signup), options);
    }

    static makeValues(cities: CCity[], signup?: boolean) {
        if(signup) cities = cities.filter(c => c.can_signup);
        const values = cities.map((s) => ({ key: s.id, name: s.name }));
        values.sort((a, b) => a.name == b.name ? 0 : a.name < b.name ? -1 : 1);
        return values;
    }
}

export class ABEventSelect extends UISelect<YId> {
    // _city?: YId;

    constructor(options: UISelectOptions<YId, YId | undefined> = {}) {
        options.placeholder = options.placeholder || $i18n.tl.ph_venue;
        options.searchable = true;
        super(cEventsKeyNameView(), options);
    }

    // set city(city: YId)
    // {
    //     if(city === this._city) return;
    //     this._city = city;

    //     const values = $tl.venues.all.filter(v => v.model.city === city).map(v => ({ key: v.model.id, name: v.model.name }));
    //     values.sort((a,b) => a.name==b.name ? 0 : a.name<b.name ? -1 : 1);

    //     this.values = values;
    //     this.value = undefined;
    // }
}

export class ABVenueSelect extends UISelect<YId> {
    _city?: YId;

    constructor(options: UISelectOptions<YId, YId | undefined> = {}) {
        options.placeholder = options.placeholder || $i18n.tl.ph_venue;
        options.searchable = true;
        super(undefined, options);
    }

    set city(city: YId) {
        if(city === this._city) return;
        this._city = city;

        const values = c_venues.all.filter(v => v.city_id === city).map(v => ({ key: v.id, name: v.name }));
        values.sort((a, b) => a.name == b.name ? 0 : a.name < b.name ? -1 : 1);

        this.values = values;
        this.value = undefined;
    }
}

export class ABSceneSelect extends UISelect<YId> {
    _venue?: YId;

    constructor(options: UISelectOptions<YId, YId | undefined>) {
        options.placeholder = options.placeholder || 'Choose a scene';
        super(undefined, options);
    }

    set venue(venue: YId | undefined) {
        if(venue === this._venue) return;
        this._venue = venue;

        const values = venue ? (c_venues.maybe(venue)!.scenes || []).map(s => ({ key: s.id, name: s.name })) : [];
        values.sort((a, b) => a.name == b.name ? 0 : a.name < b.name ? -1 : 1);

        this.values = values;
        if(values.length)
            this.value = values[0].key;
        else
            this.value = undefined;
    }
}

interface ProducerSelectOptions extends UISelectOptions<YId, YId | undefined> {
    no_producer?: boolean;
    all_producers?: boolean;
}

export class ABProducerSelect extends UISelect<YId> {
    constructor(options: ProducerSelectOptions) {
        options.placeholder = options.placeholder || 'Choose a producer';
        options.searchable = true;
        const values: UIValue<YId>[] = c_producers.all.map((p) => ({ key: p.id, name: p.name })).sort((a, b) => $fn.ICOMPARE(a.name, b.name));
        if(options.all_producers)
            values.unshift({ key: 'all' as YId, name: 'All producers' });
        if(options.no_producer)
            values.unshift({ key: '' as YId, name: '-- None --' });
        super(values, options);
    }
}

interface EventTagSelectOptions extends UISelectOptions<YId, YId | undefined> {
    all_genres?: boolean;
}

export class ABEventTagSelect extends UISelect<YId> // TODO: use undefined for 'all'
{
    constructor(options: EventTagSelectOptions = {}) {
        options.searchable = true;
        const values: UIValue<YId>[] = c_event_tags.all.map(t => ({ key: t.id, name: cEventTagName(t) })).sort((a, b) => $fn.ICOMPARE(a.name, b.name));
        if(options.all_genres)
            values.unshift({ key: 'all' as YId, name: 'All genres' });
        super(values, options);
        if(options.all_genres)
            this.value = 'all' as YId;
    }
}

interface PromoSelectOptions extends UISelectOptions<YId | null, YId | null | undefined> {
    promo_type?: 'signup' | 'giftcard';
    null_promo?: boolean;
}

export class ABPromoSelect extends UISelect<YId | null> {
    constructor(options: PromoSelectOptions = {}) {
        let all = p_promos.all;
        if(options.promo_type)
            all = all.filter(p => p.kind == options.promo_type)
        const values: UIValue<YId | null>[] = all.map(t => ({ key: t.id, name: t.name, value: t })).sort((a, b) => $fn.ICOMPARE(a.name, b.name));
        if(options.null_promo)
            values.unshift({ key: null, name: '-- none --' });
        options.generator = v => {
            const promo = v.value as PPromo;
            if(!promo)
                return $el.SPAN('ui-dropdown-item', v.name)

            return $el.DIV('ui-dropdown-item m-complex', [
                promo.name,
                $el.S(),
                $el.DIV('ui-dropdown-info', [$el.DIV('r-small', promo.kind), $el.I(pPromoDiscountDescription(promo))])
            ]);
        }
        options.searchable = true;
        super(values, options);
    }
}

export class ABLanguageSelect extends UISelect<YLanguage> {
    constructor(options: UISelectOptions<YLanguage, YLanguage | undefined> = {}) {
        const values: UIValue<YLanguage>[] = [{ key: 'sv', name: 'Svenska' }, { key: 'en', name: 'English' }, { key: 'de', name: 'Deutsch' }];
        super(values, options);
    }
}

export class ABCountrySelect extends UISelect<YCountryId> {
    constructor(options: UISelectOptions<YCountryId, YCountryId | undefined> = {}) {
        const values: UIValue<YCountryId>[] = [{ key: 'SE', name: 'Sweden' }, { key: 'DE', name: 'Germany' }];
        super(values, options);
    }
}

export class ABPlanSelect extends UISelect<CPlanId> {
    constructor(options: UISelectOptions<CPlanId, CPlanId | undefined>) {
        super([{ key: 'standard', name: 'Standard' }, { key: 'plusone', name: 'Plus 1' }, { key: 'vip', name: 'VIP' }], options);
    }
}

interface PageSelectOptions extends UISelectOptions<string, string | undefined> {
}

export class ABPageSelect extends UISelect<YId> {
    constructor(options: PageSelectOptions = {}) {
        options.searchable = true;
        const values = fPagesGetListView().then(pages => {
            return pages.filter(p => !p.is_deleted).map(p => ({ key: p.id, name: p.name })).sort((a, b) => $fn.ICOMPARE(a.name, b.name));
        })
        super(values, options);
    }
}

interface MessageTemplateSelectOptions extends UISelectOptions<YId | '', YId | '' | undefined> {
    template_channel?: MChannel;
    template_context?: MContext;
    no_template?: boolean;
}

export class ABMessageTemplateSelect extends UISelect<YId | ''> {
    constructor(options: MessageTemplateSelectOptions = {}) {
        options.generator = v => {
            const template = v.value as MTemplate;
            if(!template)
                return $el.SPAN('ui-dropdown-item', v.name)

            return $el.DIV('ui-dropdown-item m-complex', [
                template.name,
                $el.S(),
                $el.DIV('ui-dropdown-info', [$el.DIV('r-small', template.channel), $el.I(template.context)])
            ]);
        }

        const values = m_templates.getAll().then(all => {
            if(options.template_channel)
                all = all.filter(p => p.channel == options.template_channel);
            if(options.template_context)
                all = all.filter(p => p.context == options.template_context);
            const values: UIValue<YId | ''>[] = all.map(p => ({ key: p.id, name: p.name, value: p })).sort((a, b) => $fn.ICOMPARE(a.name, b.name));
            if(options.no_template)
                values.unshift({ key: '', name: '-- default --' });
            return values;
        })

        options.searchable = true;
        super(values, options);
    }
}

interface VideoSelectOptions extends UISelectOptions<YId, YId | undefined> {
}

export class ABVideoSelect extends UISelect<YId> {
    constructor(options: VideoSelectOptions = {}) {
        options.searchable = true;
        const values = v_videos.getAll().then(videos => {
            return videos.map(p => ({ key: p.id, name: p.name })).sort((a, b) => $fn.ICOMPARE(a.name, b.name));
        })
        super(values, options);
    }
}
